export default "﻿<div>\n    <div>\n        <div data-cy=\"contactEditor\" data-dojo-attach-point=\"editMainDivContainer\"></div>\n    </div>\n</div>\n"